import { render, staticRenderFns } from "./TabDraft.vue?vue&type=template&id=45c1cd10&scoped=true"
import script from "./TabDraft.vue?vue&type=script&lang=js"
export * from "./TabDraft.vue?vue&type=script&lang=js"
import style0 from "./TabDraft.vue?vue&type=style&index=0&id=45c1cd10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c1cd10",
  null
  
)

export default component.exports